// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { InvoiceModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<{ invoice: InvoiceModel }>;

export const DispatchSetInvoiceRmaLines: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ReturnRequest/SetInvoiceRmaLinesByInvoiceNumber",
        invoice: props.parameter.invoice,
    });
};

export const chain = [DispatchSetInvoiceRmaLines];

const displayInvoiceRmaLines = createHandlerChainRunner(chain, "DisplayInvoiceRmaLines");
export default displayInvoiceRmaLines;
